export default {
  fillInAllFields: 'Preencha todos os campos obrigatórios.',
  duplicateRecord: 'Já existe um registro com estes dados.',
  invalidReference: 'Um dos dados informados referencia um registro inválido.',
  constraintViolation: 'Os dados informados não atendem às regras deste cadastro.',
  sessionExpired: 'Sua sessão expirou. Atualize a página e tente novamente.',
  credentialError1: 'Credenciais inválidas.',
  credentialError2: 'Não foi possível validar as credenciais. Tente novamente.',
  errorReq: 'Falha de comunicação. Tente novamente.',
  errorOperation: 'Não foi possível concluir a operação.',
  previewSaveError: 'Não foi possível salvar antes do preview.',
  previewUrlError: 'Não foi possível montar a URL de preview.',
  seoSaveError: 'Não foi possível salvar antes da análise SEO.',
  seoAnalysisError: 'Não foi possível concluir a análise SEO.',
  seoNoResult: '<p>Nenhum resultado retornado.</p>',
  preDelete: 'Tem certeza que deseja excluir este registro?',
  successDelete: 'Registro excluído com sucesso.',
  errorDelete: 'Não foi possível excluir o registro.',
  successRecordOne: 'Registro salvo com sucesso.',
  successRecords: 'Registros salvos com sucesso.',
  addFileUploading: 'Adicione ao menos um arquivo para enviar.',
  oneUpload: 'Este campo permite apenas um arquivo por vez.',
  successUpload: '{x} arquivo(s) enviado(s) com sucesso.',
  errorUpload: 'Erro ao enviar arquivo(s).',
  cancelUpload: 'Upload cancelado.',
  jsonInvalid: 'JSON inválido',
  jsonRepair: 'Reparar automaticamente',
  jsonRepairError: 'Não foi possível reparar o JSON automaticamente.',
  jsonFormatQuestion: 'Deseja formatar o JSON?',
  jsonFormat: 'Formatar',
  jsonFormatDismiss: 'Agora não',
  jsonValidationErrorOne: 'O JSON possui 1 erro de validação.',
  jsonValidationErrorMany: 'O JSON possui {count} erros de validação.',
};
